import SideTabs from 'components/generics/buttons/SideTabs';
import { SideTabType } from 'components/generics/buttons/SideTabs/types';
import TopTabs from 'components/generics/buttons/TopTabs';
import useResponsive from 'hooks/logics/useResponsive';
import { PROFILE_TABS, TAB_MENU_ITEM, TABS_MENUS } from 'pages/profile/utils';
import { HTMLAttributes, useMemo } from 'react';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  chosenTab: PROFILE_TABS;
  onChangeMenuTab: (tab: SideTabType) => void;
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  filteredTabs: { [key in PROFILE_TABS]: TAB_MENU_ITEM[] };
}

const ProfileTabMenu = ({
  className,
  onChangeMenuTab,
  chosenTab,
  selectedTab,
  setSelectedTab,
  filteredTabs,
}: Props) => {
  const { isMobile } = useResponsive();

  const menu = useMemo(() => {
    return filteredTabs[chosenTab].map(
      ({ label, icon, iconClassName, className }) => ({
        value: label,
        label: label,
        icon: icon,
        iconClassName: iconClassName,
        className: className,
      })
    );
  }, [chosenTab, filteredTabs]);

  if (menu.length === 1) return null;
  const DynamicComponent = isMobile ? TopTabs : SideTabs;

  if (isMobile === undefined) return null;

  return (
    <div className={className}>
      <DynamicComponent
        className={classes.tabs}
        tabs={menu}
        tabClassName={classes.tab}
        onChangeTab={onChangeMenuTab}
        selectedTabClassName={classes.selectedTab}
        selectedIconClassName={classes.selectedIconClassName}
        layoutId={'menuTabs'}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
    </div>
  );
};

export default ProfileTabMenu;
